//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { ToiletAccessibleLargeSVG } from './svg'

interface ToiletAccessibleLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const ToiletAccessibleLargeIcon: React.FC<ToiletAccessibleLargeIconProps> = forwardRef<
  ToiletAccessibleLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={ToiletAccessibleLargeSVG}
    sx={sx}
  />
))
